document.addEventListener('variant:change', function (event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  const container = document.querySelector('[data-variant-accessories]');
  if (!container) return;

  const url = new URL(window.location.href);
  url.searchParams.set("variant", variant.id);

  fetch(url.toString(), {
    method: "GET",
    headers: { "X-Requested-With": "XMLHttpRequest" }
  })
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const updated = doc.querySelector('[data-variant-accessories]');
      if (updated) {
        container.innerHTML = updated.innerHTML;
      }
    })
    .catch(err => console.error("Variant accessory reload failed:", err));
});

document.addEventListener('variant:change', async (event) => {
  const variant = event.detail.variant;
  if (!variant) return;

  const container = document.querySelector('[data-variant-accessories-wrapper]');
  if (!container) return;

  const url = `${window.location.pathname}?variant=${variant.id}&section_id=main-product`;

  const res = await fetch(url);
  const html = await res.text();

  const dom = new DOMParser().parseFromString(html, 'text/html');
  const updated = dom.querySelector('[data-variant-accessories-wrapper]');

  if (updated) {
    container.replaceWith(updated);
  }
});


